<template>
  <div
    :class="css+(grow?' grow':' button')+(!disabled?' cursor':' opacity')"
    :style="style"
    @click="!disabled&&click()"
  >
    <div style="margin-right:5px;padding:2px;" v-if="loading">
      <i class="el-icon-loading" />
    </div>
    <font>{{text}}</font>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    css() {
      let css = "";
      switch (this.type) {
        case "primary":
          css = "primary";
          break;
        default:
          break;
      }
      return css;
    },
    style() {
      let style = "";
      if (this.color) {
        style += "color:" + this.color + ";";
      }
      return style;
    }
  },
  methods: {
    click() {
      this.$emit("click");
    }
  },
  props: {
    type: {
      type: String,
      default: () => ""
    },
    text: {
      type: String,
      default: () => ""
    },
    grow: {
      type: Boolean,
      default: () => false
    },
    color: {
      type: String,
      default: () => undefined
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  }
};
</script>

<style scoped>
.button {
  width: 100%;
  height: 38px;
  line-height: 38px;
  min-width: 100px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  justify-content: center;
}

.grow {
  display: inline-block;
  width: auto;
  height: 38px;
  line-height: 38px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0px 16px;
}

.primary {
  color: #fff;
  background-color: #1890ff;
  border-width: 0;
}

.opacity {
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/views/components/Button.vue